/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.styles

import net.scalytica.blaargh.CssSettings._
import net.scalytica.blaargh.components._
import net.scalytica.blaargh.pages.AboutPage
import scalacss.ScalaCssReact._
import scalacss.internal.mutable.GlobalRegistry

object CSSRegistry {

  def load(): Unit = {
    GlobalRegistry.register(
//      BaseCSS,
      BlaarghBootstrapCSS,
      Menu.Styles,
      ArticleCard.Styles,
      AboutPage.Styles,
      ArticleView.Styles
    )
  }

  GlobalRegistry.onRegistration(_.addToDocument())
}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/styles/CSSRegistry.scala